/**
 * AccountPickerScreen — « Qui utilise Masteur ? » (`family-account-selection`), sur le design system.
 *
 * Portage de `src/auth/FamilyAccountSelectionScreen.js`, monté dans la pile d'avant connexion (on y
 * arrive après une connexion à plusieurs comptes et après « Changer de compte »). Un fil : les groupes
 * (`accountPickerViewModel`, patron C — les comptes de l'appareil sont déjà dans le store), les gestes
 * (`useAccountPickerState`), puis la page. Le titre de l'onglet web vient de la route (`headerTitle`).
 */
import { useSelector } from "react-redux"

import { AccountPickerPage } from "../../../../../../design-system"
import { accountPickerViewModel } from "../../../../view-models/auth/AccountPicker/accountPickerViewModel"
import { AuthStatusBar } from "../AuthStatusBar"
import { useAccountPickerState } from "./useAccountPickerState"

export function AccountPickerScreen() {
    const vm = useSelector(accountPickerViewModel)
    const gestures = useAccountPickerState()

    return (
        <>
            <AuthStatusBar />
            <AccountPickerPage groups={vm.groups} {...gestures} />
        </>
    )
}

export default AccountPickerScreen
